import { render, staticRenderFns } from "./LevelUpDialog.vue?vue&type=template&id=af9e8c7a&"
import script from "./LevelUpDialog.vue?vue&type=script&lang=js&"
export * from "./LevelUpDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports